// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eUZlxSTSQO1ejAMoYv4J {
  --jp-currency-position: absolute;
  --jp-currency-margin-left: 0;
  --jp-currency-line-height: 1;
  --jp-level-padding-top: 47px;
}
.eUZlxSTSQO1ejAMoYv4J div[data-level='grand'] {
  --jp-grand-width: 250px;
  --jp-grand-height: 99px;
  --jp-grand-currency-font-size: 9.5px;
  --jp-level-value-padding-left: 40px;
  --jp-level-value-padding-right: 40px;
}
.eUZlxSTSQO1ejAMoYv4J [data-currency-level='grand'] {
  left: 25px;
}
`, "",{"version":3,"sources":["webpack://./src/features/jackpots/components/variants/InstantLink/InstantLink.module.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,oCAAoC;EACpC,mCAAmC;EACnC,oCAAoC;AACtC;AACA;EACE,UAAU;AACZ","sourcesContent":[".instantLinkTheme {\n  --jp-currency-position: absolute;\n  --jp-currency-margin-left: 0;\n  --jp-currency-line-height: 1;\n  --jp-level-padding-top: 47px;\n}\n.instantLinkTheme div[data-level='grand'] {\n  --jp-grand-width: 250px;\n  --jp-grand-height: 99px;\n  --jp-grand-currency-font-size: 9.5px;\n  --jp-level-value-padding-left: 40px;\n  --jp-level-value-padding-right: 40px;\n}\n.instantLinkTheme [data-currency-level='grand'] {\n  left: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"instantLinkTheme": `eUZlxSTSQO1ejAMoYv4J`
};
export default ___CSS_LOADER_EXPORT___;
